// extracted by mini-css-extract-plugin
module.exports = {"detail":"index_detail_27298","listWrap":"index_listWrap_38Rg6"};